import React from "react";
import Profile from "../Profile/Profile";

function Home() {
  return (
    <div>
      <Profile />
    </div>
  );
}

export default Home;
